import React from 'react';
import AdminLayout from '../components/AdminLayout';
import ExternalInvoices from '../components/ExternalInvoices';

/**
 * AdminExternalInvoicesPage - External invoices management
 * 
 * Displays NetSuite external invoices with fetch functionality.
 * Migrated from: contently-contently/app/javascript/app/components/admin2/external_invoices/
 */
function AdminExternalInvoicesPage() {
  return (
    <AdminLayout title="External Invoices" pageTitle="External invoices">
      <ExternalInvoices />
    </AdminLayout>
  );
}

export default AdminExternalInvoicesPage;
